import { createApp, markRaw } from 'vue';
import * as Sentry from '@sentry/vue';
import App from './App.vue';
import router from './router';
import { isMobile } from '@utils/util';
import '@utils/auth'; // 初始化账号登录权限
import { createPinia } from 'pinia';
import { i18n } from '@utils/setupI18n';
import Loading from '@com/loading.vue';
import Icon from '@com/icon.vue';
import { Tooltip, options, vTooltip } from 'floating-vue';
import 'floating-vue/dist/style.css';
import 'flag-icon-css/css/flag-icons.css';
import 'driver.js/dist/driver.css';

const app = createApp(App);
const pinia = createPinia();

const isDev = import.meta.env.MODE === 'development' ? true : false;

pinia.use(({ store }) => {
  store.$router = markRaw(router);
});

// Sentry.init({
//   app,
//   dsn: import.meta.env.VUE_SENTRY_DNS,
//   release: isDev ? 'development' : window?.__APP_VERSION__,
//   tracePropagationTargets: ['localhost', /^https:\/\/www.visionstory\.ai/],
//   tracesSampleRate: isDev ? 1.0 : 0.1,
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: isDev ? 1.0 : 0.1,
//   integrations: [
//     Sentry.browserTracingIntegration({ router }),
//     Sentry.replayIntegration(),
//     Sentry.vueIntegration({
//       tracingOptions: {
//         trackComponents: true,
//       },
//     }),
//   ],
// });

if (isMobile) {
  options.themes.tooltip.triggers = ['click'];
}

app
  .use(pinia)
  .use(router)
  .use(i18n)
  .component('icon', Icon)
  .component('loading', Loading)
  .component('Tooltip', Tooltip)
  .directive('tooltip', vTooltip)
  .mount('#app');
